import bmbLogo1 from '../images/bmb-logo1.png';
import bmbLogo2 from '../images/bmb-logo2.png';
import bmbLive1 from '../images/bmb-live1.png';
import bmbLive2 from '../images/bmb-live2.webp';

export const musicData = {
    Songs: [
      {
        title: { is: "Fuglar í móa", en: "Fuglar í móa" },
        author: { is: "Brynjar Már Björnsson", en: "Brynjar Már Björnsson" },
        url: "https://storage.googleapis.com/music-files-mycreations-bmb/SongsforSubmit/Fuglar-i-moa.wav",
        backgroundImage: bmbLive1,
        type: "audio/wav",
      },
      {
        title: { is: "Lil Sun Q", en: "Lil Sun Q" },
        author: { is: "Brynjar Már Björnsson", en: "Brynjar Már Björnsson" },
        url: "https://storage.googleapis.com/music-files-mycreations-bmb/SongsforSubmit/LilSunQ_Betterv.wav",
        backgroundImage: bmbLive1,
        type: "audio/wav",
      },
      {
        title: { is: "A Fair Spring", en: "A Fair Spring" },
        author: { is: "Brynjar Már Björnsson", en: "Brynjar Már Björnsson" },
        url: "https://storage.googleapis.com/music-files-mycreations-bmb/SongsforSubmit/Scoring9-Idea1-ending.wav",
        backgroundImage: bmbLive2,
        type: "audio/wav",
      },
      {
        title: { is: "Gaman Saman", en: "Gaman Saman" },
        author: { is: "Brynjar Már Björnsson", en: "Brynjar Már Björnsson" },
        url: "https://storage.googleapis.com/music-files-mycreations-bmb/SongsforSubmit/GamanSaman.mp3",
        backgroundImage: bmbLogo1,
        type: "audio/mp3",
      },
      {
        title: { is: "Bolem Dastnnu", en: "Bolem Dastnnu" },
        author: { is: "Brynjar Már Björnsson", en: "Brynjar Már Björnsson" },
        url: "https://storage.googleapis.com/music-files-mycreations-bmb/SongsforSubmit/BolemDastnnu.wav",
        backgroundImage: bmbLogo2,
        type: "audio/wav",
      },
      {
        title: { is: "Up in the Sky", en: "Up in the Sky" },
        author: { is: "Brynjar Már Björnsson", en: "Brynjar Már Björnsson" },
        url: "https://storage.googleapis.com/music-files-mycreations-bmb/SongsforSubmit/Brynjar_UpInTheSky.wav",
        backgroundImage: bmbLive1,
        type: "audio/wav",
      },
      // ... more songs ...
    ],
    Trailers: [
      {
        title: "Trailer #1",
        author: "Brynjar Már Björnsson",
        url: "https://storage.googleapis.com/music-files-mycreations-bmb/Brynjar-Mar-Bjornsson_CV_Composer/Trailers/Brynjar_Oppenheimer_Trailer.mov",
        backgroundImage: "pathToBackground.png",
        type: "video/mp4",
      },
      // ...
    ],
  };
  